import {Component, OnInit} from '@angular/core';
import {BonusService} from '../bonus.service';
import {Constants} from '../../../shared/utils/constants';

@Component({
  selector: 'fx-bonus-top-loss-history',
  templateUrl: './bonus-top-loss-history.component.html',
  styleUrls: ['./bonus-top-loss-history.component.sass']
})
export class BonusTopLossHistoryComponent implements OnInit {
  loading = false;
  addChangeModeTopLoss = false;
  valueAmountTopLoss = null;
  data = [];
  condition: any = {
    q: '',
  };
  currency = '¥';
  constructor(
    private bonusService: BonusService,
  ) { }

  ngOnInit(): void {
    this.searchLossCutTransaction();
  }
  searchLossCutTransaction(search?: boolean): void {
    this.loading = search;
    const params = {
      q: this.condition.keyword
    };
    this.getTransactions(params);
  }
  private getTransactions(params: any): void {
    this.bonusService.getBonusLossCutHistory(params)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.data = res.data.transactions;
        }
      });
  }
  onRefresh(): void {
  }
  onChangeAmountTopLoss(event): void {
    this.addChangeModeTopLoss = (event === 'add');
  }
  onSubmitAmountTopLoss(): void {
    console.log('top loss')
  }
}
